import React, { useCallback, useState, useRef } from 'react';
import classnames from 'classnames';
import { NO_OP } from '../../constants';
import { useDebounce } from 'react-use';

import './button-group-component.scss';

const CUSTOM_TYPE = 'custom';
const REGULAR_TYPE = 'regular';

export default function ButtonGroup({
  options = [],
  onOptionChange = NO_OP,
  withCustom = false,
  value = '',
  type = '',
}) {
  const [selectedValue, setSelectedValue] = useState(value);
  const [selectedType, setSelectedType] = useState(type);
  const valueChanged = useRef(false);

  const onOptionSelected = useCallback(
    (value) => {
      valueChanged.current = true;
      setSelectedType(REGULAR_TYPE);
      setSelectedValue(value);
    },
    [setSelectedValue, setSelectedType]
  );

  const onCustomInputFocus = useCallback(() => {
    if (selectedType !== CUSTOM_TYPE) {
      setSelectedType(CUSTOM_TYPE);
      setSelectedValue('');
    }
  }, [setSelectedType, selectedType]);

  useDebounce(
    () => {
      if (valueChanged.current) {
        onOptionChange({ type: selectedType, value: selectedValue });
      }
    },
    500,
    [selectedValue]
  );

  const onCustomTextChange = useCallback(
    (e) => {
      valueChanged.current = true;
      setSelectedValue(e?.target?.value);
    },
    [setSelectedValue]
  );

  const renderCustom = () => {
    const isCustomSelected = selectedType === CUSTOM_TYPE;
    const customValue = isCustomSelected ? selectedValue : '';

    return (
      <div className={classnames('option custom', { selected: isCustomSelected })}>
        <input
          type="text"
          value={customValue}
          placeholder="Type your own"
          onChange={onCustomTextChange}
          onFocus={onCustomInputFocus}
        />
      </div>
    );
  };

  const renderOptions = () => {
    return options.map((option, index) => {
      const isSelected = selectedValue === option.value && selectedType !== CUSTOM_TYPE;
      return (
        <div
          key={index}
          className={classnames('option', { selected: isSelected })}
          onClick={() => onOptionSelected(option.value)}
        >
          {option.label}
        </div>
      );
    });
  };

  return (
    <div className="button-group">
      {renderOptions()}
      {withCustom && renderCustom()}
    </div>
  );
}
